import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login/login'
import register from '@/components/login/register'
import Registration from '@/components/login/Registration'
import password from '@/components/login/password'
import mypasswordcg from '@/components/login/mypasswordcg'
import replace from '@/components/replace/replace'
import replace2 from '@/components/replace/replace2'
import Recharge from '@/components/Recharge/Recharge'
import Novel from '@/components/Novel/Novel'
import works from '@/components/Novel/works'
import detailss from '@/components/Novel/detailss'
import Cartoon from '@/components/Cartoon/Cartoon'
import details from '@/components/Cartoon/details'
import particulars from '@/components/Cartoon/particulars'
import information from '@/components/Usercenter/information'
import Collection from '@/components/Usercenter/Collection'
import Usercenter from '@/components/Usercenter/Usercenter'
import comment from '@/components/Usercenter/comment'
import follow from '@/components/Usercenter/follow'
import fans from '@/components/Usercenter/fans'
import Noresult from '@/components/search/Noresult'
import searchnovel from '@/components/search/searchnovel'
import searchcartoon from '@/components/search/searchcartoon'
import searchnoresult from '@/components/search/searchnoresult'
import searchzixun from '@/components/search/searchzixun'
import noticeone from '@/components/Usercenter/noticeone'
import Catalog from '@/components/Cartoon/Catalog'
import index from '@/components/index/index'
import TwoD from '@/components/index/TwoD'
import publicnum from '@/components/index/publicnum'
import Exhibition from '@/components/index/Exhibition'
import infoDetail from '@/components/index/infoDetail'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
// 导入vue-resource
import VueResource from 'vue-resource'
// 注册resource
Vue.use(VueResource)

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'index',
      component: Novel
    },
    {
      path: '/Usercenter',
      name: 'Usercenter',
      component: Usercenter,
      children: [{
          path: '',
          component: information
        },
        {
          path: 'Usercenter',
          component: Usercenter
        },
        {
          path: '/Collection',
          component: Collection
        },
        {
          path: '/noticeone',
          component: noticeone
        },
        {
          path: '/comment',
          component: comment
        },
        {
          path: '/follow',
          component: follow
        },
        {
          path: '/fans',
          component: fans
        },
      ]
    },
    {
      path: '/Noresult',
      name: 'Noresult',
      component: Noresult,
      children: [{
          path: '',
          component: searchnoresult
        },
        {
          path: '/searchzixun',
          component: searchzixun
        },
        {
          path: '/searchnovel',
          component: searchnovel
        },
        {
          path: '/searchcartoon',
          component: searchcartoon
        },
      ]
    },

    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/Registration',
      name: 'Registration',
      component: Registration
    },
    {
      path: '/password',
      name: 'password',
      component: password
    },
    {
      path: '/mypasswordcg',
      name: 'mypasswordcg',
      component: mypasswordcg
    },
    {
      path: '/replace2',
      name: 'replace2',
      component: replace2
    },
    {
      path: '/details',
      name: 'details',
      component: details
    },
    {
      path: '/detailss',
      name: 'detailss',
      component: detailss
    },
    {
      path: '/Noresult',
      name: 'Noresult',
      component: Noresult
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/TwoD',
      name: 'TwoD',
      component: TwoD
    },
    {
      path: '/publicnum',
      name: 'publicnum',
      component: publicnum
    },
    {
      path: '/Novel',
      name: 'Novel',
      component: Novel
    },
    {
      path: '/Exhibition',
      name: 'Exhibition',
      component: Exhibition
    },
    {
      path: '/Cartoon',
      name: 'Cartoon',
      component: Cartoon
    },
    {
      path: '/Catalog',
      name: 'Catalog',
      component: Catalog
    },
    {
      path: '/particulars',
      name: 'particulars',
      component: particulars
    },
    {
      path: '/works',
      name: 'works',
      component: works
    },
    {
      path: '/infoDetail',
      name: 'infoDetail',
      component: infoDetail
    },
    {
      path: '/replace',
      name: 'replace',
      component: replace
    },
    {
      path: '/Recharge',
      name: 'Recharge',
      component: Recharge
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js